import { generatePath } from 'react-router';

import LinkCell from 'components/Grids/DataGrid/Cells/LinkCell';
import { appReactMemo } from 'hocs';
import { ROUTES } from 'routes/config/constants';

import { TClientInstrumentRowCellProps } from './types';

const MerchantNameCell = ({ item, ...rest }: TClientInstrumentRowCellProps) => {
  const { id, name } = item.merchantTerminal.merchant;
  const { PARAMS, PATH } = ROUTES.ORGANIZATIONS.SUB_PATH.ORGANIZATION;

  const viewOrganization = generatePath(PATH, {
    [PARAMS.ID]: String(id),
  });

  return <LinkCell {...rest} item={item} text={name} to={viewOrganization} />;
};

export default appReactMemo(MerchantNameCell);
